import React, { useState, useEffect } from "react";
import { useBar } from "../../../../context/BarContext";
import { useBarOwnerData } from "../../../../context/BarOwnerDataContext";
import BarOwnerArtistCard from "../BarOwnerArtistCard";
import ManagementArtistProfileModal from "./ManagementArtistProfileModal";

const ArtistsByBar = ({ isMapsLoaded = false }) => {
  const { selectedBar } = useBar();
  const {
    ensureOwnerArtistsLoaded,
    fetchManagementArtists,
    getManagementArtists,
    getBars,
    fetchBars,
    invalidateCache,
  } = useBarOwnerData();
  const [selectedArtist, setSelectedArtist] = useState(null);

  const {
    artists: allArtists,
    associations: artistBarAssociations,
    loading,
  } = getManagementArtists();

  useEffect(() => {
    ensureOwnerArtistsLoaded();
    const barsCache = getBars();
    if (!barsCache.bars?.length && !barsCache.loading) {
      fetchBars();
    }
  }, [ensureOwnerArtistsLoaded, getBars, fetchBars]);

  const hasArtists = allArtists.length > 0;

  if (loading) {
    return (
      <div className="artists-by-bar-section">
        <div
          className="chat-messages-loading"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "3rem",
            minHeight: "400px",
            width: "100%",
          }}
        >
          <div className="spinner" aria-hidden="true" />
          <p
            style={{
              color: "var(--text-secondary)",
              margin: 0,
              marginTop: "1rem",
            }}
          >
            Loading artists...
          </p>
        </div>
      </div>
    );
  }

  if (!hasArtists) {
    return (
      <div className="artists-by-bar-section">
        <div className="no-artists-message">
          <span className="no-data-icon">🎤</span>
          <h3>No Artists Yet</h3>
          <p>No artists have been added to any of your bars yet</p>
        </div>
      </div>
    );
  }

  const handleRefresh = () => {
    invalidateCache("managementArtists");
    fetchManagementArtists();
  };

  return (
    <div className="artists-by-bar-section">
      <div className="bars-grid bars-grid--artists">
        {allArtists.map((artist) => {
          const assocs = artistBarAssociations[artist.artist_id] || [];
          const hasPending = assocs.some((a) => a.status === "pending");
          return (
            <BarOwnerArtistCard
              key={artist.artist_id}
              artist={artist}
              onClick={() => setSelectedArtist(artist)}
              hasPending={hasPending}
            />
          );
        })}
      </div>

      {selectedArtist && (
        <ManagementArtistProfileModal
          isOpen={!!selectedArtist}
          onClose={() => setSelectedArtist(null)}
          artist={selectedArtist}
          associations={artistBarAssociations[selectedArtist.artist_id] || []}
          selectedBar={selectedBar}
          isMapsLoaded={isMapsLoaded}
          onRefresh={handleRefresh}
        />
      )}
    </div>
  );
};

export default ArtistsByBar;
